import { Component, Vue } from 'vue-property-decorator';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import IUsersGroup from '@/interfaces/IUsersGroup';

import GroupForm from '../GroupForm/GroupForm.vue';

@Component({
    name: 'GroupCreate',
    components: {
        CardHeader,
        GroupForm
    }
})
export default class GroupCreate extends Vue {
    private form: IUsersGroup = {
        name: '',
        description: '',
        roles: [],
        users: []
    };
};


